import { apply, create } from "mutative";
import { createImmerPatchSequence } from "../history/patch";
/**
 * HACK: For filtering out patches with certain problematic paths.
 *
 * Right now `selectedObjectUids` is only meaningful to the current user, we
 * don't use it anywhere else such as web worker, simulator, etc. More
 * importantly we don't want to send it to remote session via action record
 * because that leads to unexpected behavior. QUESTION: why wouldn't we want to
 * filter it out in the remote client? Then we could also restore selection when
 * restoring in change history.
 *
 * Second, `subDocumentData` can be too big for the 1MB limit of Firestore,
 * and so we refetch it as needed after applying an action record. See
 * maybeRefetchSubDocumentData.
 */
export function patchFilter(patch) {
    return !patch.path.includes("selectedObjectUids") && !patch.path.includes("subDocumentData");
}
/**
 * Applies Mutative-compatible patches to a state object or draft.
 * Use this instead of Immer's `applyPatches` when working with Mutative drafts.
 */
export function applyMutativePatches(state, patches) {
    return apply(state, patches);
}
/**
 * Wraps a function up nicely so that it doesn't need to any of the immer juggling, and instead just gets
 * handed a draft state to modify.  The mutator will be applied, and the transformation is guaranteed to
 * correctly advance the history by appending the generated patches to the state.
 *
 * HACK: Ideally this function should only be used to update document data; right now we also use it to update
 * the allBakedNodesStore, for the purpose of enabling incremental DRC.
 * TODO: Now that `allBakedNodesStore` is replaced with the document service, change back the typing here and make it
 * only work with document data
 */
export function withHistoryUpdate(previousDocument, mutationFn, patchCreationStrategy = "create") {
    const [newDocument, forward, reverse] = create(previousDocument, mutationFn, { enablePatches: true });
    // If the change from the mutation function is effectively a no-op, we don't record changes as there's no
    // need.  Otherwise, we record the immer patches and update the document state accordingly.
    if (forward.length == 0) {
        return newDocument;
    }
    else {
        const latestPatches = { forward, reverse };
        const newPatch = createImmerPatchSequence(latestPatches, patchCreationStrategy, newDocument.latestPatch);
        return {
            ...newDocument,
            latestPatch: newPatch,
            latestActionRecordUid: newPatch.uid,
        };
    }
}
//# sourceMappingURL=helpers.js.map